<template>
  <div class='h-outTabs'>
    <ejs-tab id='trackTaskTab' ref='tabRef' :showCloseButton='true' :removing='changeTab' :removed='removeTabFunc' :selecting='tabSelect' heightAdjustMode='Auto'>
      <e-tabitems>
        <e-tabitem :header='tab.headerText' content='#trackTable' cssClass='h-tab-noClose'></e-tabitem>
      </e-tabitems>
    </ejs-tab>
    <div id='trackTable' class='h100vh-140'>
      <BatchInitNeCfgMenu   ref="BatchInitNeCfgMenu" @methodEnum='methodEnum' @keywords='changeKeywords'></BatchInitNeCfgMenu>
      <BatchInitNecfgTable :trackType='trackType' ref="BatchInitNecfgTable" ></BatchInitNecfgTable>
    </div>
    <CustomDialog ref='selectStandardBsDialog' :element='selectStandardBsDialogSetting.element' :styles='selectStandardBsDialogSetting.style'>
      <template v-slot:dialog-content>
        <SelectStandardBs ref='selectStandardBs'></SelectStandardBs>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import BatchInitNeCfgMenu from './BatchInitNeCfgMenu';
import BatchInitNecfgTable from './BatchInitNeCfgTable';
import DownloadFile from '../ConfigInEx/DownloadFile';
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
import SelectStandardBs from './SelectStandardBs.vue';
import CustomDialog from '../../common/CustomDialog';
// import socketInstance from '../../../plugins/stompSock';

export default {
  name: 'TrackTaskList',
  components: {
    BatchInitNeCfgMenu,
    BatchInitNecfgTable,
    CustomDialog,
    SelectStandardBs
  },
  props: ['trackType'],
  data() {
    return {
      exportAll: false,
      selectStandardBsDialogSetting: {
        style: {
          width: '450px',
          height: 'auto',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('System.selectStandardBs')}`,
          refName: 'select',
          buttonGroup: [
            { click: this.closeSelectStandardBsDialog, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.exportConfigurationFile, buttonModel: { content: this.$t('System.confirm') } }
          ],
          isClose: true
        }
      },
      locale: localStorage.getItem('locale'),
      tab: {
        headerText: { text: this.$t('System.configMenu') }
      },
      tabList: [this.$t('Track.taskList')],
      tabListVallue: [this.$t('Track.taskList')]
    };
  },
  methods: {
    exportConfigurationFile() {
      const nodeList = this.$refs.selectStandardBs.getNodeList();
      if (nodeList.length > 0) {
        const nodeId = nodeList[0].id;
        const params = this.$refs.BatchInitNecfgTable.getCheckedData(this.exportAll,nodeId);
        this.closeSelectStandardBsDialog();
        this.$refs.BatchInitNeCfgMenu.exportData(params);
      } else {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.standardBsWarning')});
        return;
      }
    },
    closeSelectStandardBsDialog() {
      this.$refs.selectStandardBsDialog.close();
    },
    tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    changeKeywords(args) {
      console.log("--------",args)
      this.$refs.BatchInitNecfgTable.queryConditions.keywords = args;
      this.$refs.BatchInitNecfgTable.page.pageNo = "1";
      this.$refs.BatchInitNecfgTable.getTrackListData();
    },

    downloadTab(args) {
      const title = this.$t('Track.download');
      const item = {
        header: { text: title },
        content() {
          return {
            template: DownloadFile
          };
        }
      };
      this.addTabFunc(title, item, args);
    },
    addTabFunc(title, item, args) {
      const tabObj = this.$refs.tabRef.ej2Instances;
      const itemLength = document.querySelectorAll('#trackTaskTab .e-tab-header .e-toolbar-item').length;
      const index = this.tabList.findIndex(v => v === title);
      if (index > 0) {
        tabObj.select(index);
      } else if (title !== this.$t('Track.download') && title.indexOf('.json') === -1) {
        const missionTab = this.tabList.filter(v => v !== this.$t('Track.download') && v.indexOf('.json') === -1);
        if (missionTab.length > 5) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.maximumMissionNumber')});
        } else {
          this.tabList.push(title);
          this.tabListVallue.push(args);
          tabObj.addTab([item], itemLength);
          tabObj.select(itemLength);
        }
      } else {
        this.tabList.push(title);
        this.tabListVallue.push(args);
        tabObj.addTab([item], itemLength);
        tabObj.select(itemLength);
      }
      bus.$emit(title, args);
    },
    removeTabFunc(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      bus.$off(this.tabList[index]);
      if (this.tabList[index] !== this.$t('Track.download') && this.tabList[index].indexOf('.json') === -1) {
        // 只有跟踪页面关闭websocket
        // socketInstance.stopReceiveTopicMsg(`track_${this.tabListVallue[index][0].taskId}`, '/user/#/TrackReportServer');
      }
      this.tabList.splice(index, 1);
      this.tabListVallue.splice(index, 1);
    },
    changeTab(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      const tabObj = this.$refs.tabRef.ej2Instances;
      const selecteIdndex = tabObj.selectedItem;
      const itemLength = document.querySelectorAll('#trackTaskTab .e-tab-header .e-toolbar-item').length;
      if (index == selecteIdndex) {
        if (index == (itemLength - 1)) {
          tabObj.select(itemLength - 2);
        } else {
          tabObj.select(itemLength - 1);
        }
      }
    },
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          // this.$refs.trackTable.queryConditions.keywords = '';
          this.$refs.BatchInitNecfgTable.page.pageNo = "1";
          this.$refs.BatchInitNecfgTable.getTrackListData();
          break;
        case 'export':
          this.exportAll = false;
          const params = this.$refs.BatchInitNecfgTable.getCheckedData(true);
          console.log(params)
          let data = params.data;
          if(data.length ===0){
            EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
            return;
          }
          this.$refs.selectStandardBsDialog.show();
          break;
        case 'exportAll':
          if(this.$refs.BatchInitNecfgTable.page.totalCount>0){
            this.exportAll = true;
            this.$refs.selectStandardBsDialog.show();
          }else{
            EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
          }
          break;
        case 'import':
          this.$refs.BatchInitNeCfgMenu.addDialog();
          break;
        case 'refrush':
          this.$refs.BatchInitNecfgTable.queryConditions.keywords = this.$refs.BatchInitNeCfgMenu.queryConditions.keywords;
          this.$refs.BatchInitNecfgTable.page.pageNo = "1";
          this.$refs.BatchInitNecfgTable.hasSelectedAll = false;
          this.$refs.BatchInitNecfgTable.lastPageCount = 0;
          this.$refs.BatchInitNecfgTable.getTrackListData();
          break;
        default:
      }
    }
  },
  mounted() {
    bus.$on('downloadTableTab', (args) => {
      console.log(1, args);
      this.downloadTableTab(args);
    });
  },
  beforeDestroy() {
    bus.$off('downloadTableTab');
  }
};
</script>
